import playerControlsSettingsPopoverTemplate from './player-controls-settings-popover.html';

/* @ngInject */
export const templates = function ($templateCache) {
	$templateCache.put('player-controls/player-controls-settings-popover.html', playerControlsSettingsPopoverTemplate);
};
